"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdFormik = require("cccisd-formik");
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _MessageViewer = _interopRequireDefault(require("../../../../pages/Messaging/MessageViewer"));
var _messageConditionTranslator = _interopRequireDefault(require("../../../../helpers/messageConditionTranslator.js"));
var _withMessageList = _interopRequireDefault(require("../../../../pages/Messaging/withMessageList"));
var _participants = _interopRequireDefault(require("./participants.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var SendMessageNow = /*#__PURE__*/function (_React$Component) {
  _inherits(SendMessageNow, _React$Component);
  var _super = _createSuper(SendMessageNow);
  function SendMessageNow() {
    var _this;
    _classCallCheck(this, SendMessageNow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: true,
      method: undefined,
      recipients: [],
      templateId: -1
    });
    _defineProperty(_assertThisInitialized(_this), "getAllRecipients", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var recipients;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _cccisdApollo.client.query({
                query: _this.props.messageQuery || _participants["default"],
                fetchPolicy: 'network-only',
                variables: {
                  groupId: _this.props.groupId,
                  roleHandle: _this.props.roleHandle,
                  deploymentHandle: _this.props.deployment.deploymentHandle
                }
              }).then(function (res) {
                return res.data.roles.anyRoleList.map(function (role) {
                  return {
                    pawnId: role.pawn.pawnId,
                    status: role.assignmentProgress.status,
                    user: role.user
                  };
                });
              })["catch"](function (err) {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: 'An error occurred.',
                  duration: 5000
                });
                console.error(err);
              });
            case 2:
              recipients = _context.sent;
              _context.next = 5;
              return _this.setState({
                loading: false,
                recipients: recipients
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "getSelectedRows", function () {
      var selectedRows = _this.props.rtComponent.table.state.selectedRows;
      return selectedRows;
    });
    _defineProperty(_assertThisInitialized(_this), "getSelectedRowData", function () {
      var rtState = _this.props.rtComponent.state;
      var tableState = _this.props.rtComponent.table.state;
      return tableState.data.filter(function (row) {
        return tableState.selectedRows.includes(row["".concat(rtState.pawnIdPath, "pawnId")]);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getEligibleRows", function (values) {
      var allRows = _this.getSelectedRowData();
      var method = values.method;
      if (_this.hasRecipientChain(values)) {
        return allRows;
      }
      return allRows.filter(function (row) {
        if (method === 'email') {
          return row["".concat(_this.props.rtComponent.state.userPath, "user.email")];
        }
        if (method === 'sms') {
          return row["".concat(_this.props.rtComponent.state.userPath, "user.phone")];
        }
        return false;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getAllEligibleRecipients", function (method) {
      return _this.state.recipients.filter(function (r) {
        if (method === 'email') {
          return r.user.email;
        }
        if (method === 'sms') {
          return r.user.phone;
        }
        return false;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getConditionalPawnIdsFromRecipients", function (recipients, condition) {
      if (condition === 'all_respondents') {
        return recipients.map(function (r) {
          return r.pawnId;
        });
      }
      if (condition === 'complete') {
        return recipients.filter(function (r) {
          return r.status === 'Complete';
        }).map(function (r) {
          return r.pawnId;
        });
      }
      if (condition === 'incomplete') {
        return recipients.filter(function (r) {
          return r.status === 'In Progress';
        }).map(function (r) {
          return r.pawnId;
        });
      }
      if (condition === 'not_started') {
        return recipients.filter(function (r) {
          return r.status === null;
        }).map(function (r) {
          return r.pawnId;
        });
      }
      if (condition === 'incomplete_or_not_started') {
        return recipients.filter(function (r) {
          return r.status === 'In Progress' || r.status === null;
        }).map(function (r) {
          return r.pawnId;
        });
      }
      return [];
    });
    _defineProperty(_assertThisInitialized(_this), "getPreviewMessageObject", function (values) {
      var msg = _this.props.messageList.find(function (e) {
        return e.messageId === values.template;
      });
      var msgLabel = msg ? msg.settings.label : '';
      var condition = !_this.getSelectedRows().length && msg ? msg.condition : 'scheduled';
      var eligiblePawnIds = _this.getEligibleRows(values).map(function (e) {
        return e["".concat(_this.props.rtComponent.state.pawnIdPath, "pawnId")];
      });
      var selectedRecipients = eligiblePawnIds.length ? eligiblePawnIds : [];
      var conditionalPawnIdsFromAllRecipients = _this.getConditionalPawnIdsFromRecipients(_this.state.recipients, condition);
      var msgObj = {
        condition: 'scheduled',
        messageMethod: values.method,
        category: 'preview',
        recipients: _this.getSelectedRows().length ? selectedRecipients : conditionalPawnIdsFromAllRecipients,
        settings: {
          label: msgLabel,
          recipientsType: 'respondent'
        }
      };
      var messageInfo = values.method === 'email' ? {
        subject: values.subject,
        body: values.body,
        outroLines: values.outroLines,
        actionText: values.actionText,
        actionUrl: values.actionUrl
      } : {
        body: values.body
      };
      msgObj.messageInfo = messageInfo;
      return msgObj;
    });
    _defineProperty(_assertThisInitialized(_this), "hasRecipientChain", function (values) {
      var settings = _this.props.deployment.settings;
      var chainPath = values.method === 'email' ? 'chainEmailFromPawn' : 'chainPhoneFromPawn';
      var recipientChain = settings && settings[chainPath];
      return !!recipientChain;
    });
    _defineProperty(_assertThisInitialized(_this), "renderSendInfo", function (values, selectedTemplate) {
      var recipients = _this.state.recipients;
      var selectedRows = _this.getSelectedRows();
      var eligibleSelected = _this.getSelectedRowData().filter(function (row) {
        if (values.method === 'email') {
          return row["".concat(_this.props.rtComponent.state.userPath, "user.email")];
        }
        if (values.method === 'sms') {
          return row["".concat(_this.props.rtComponent.state.userPath, "user.phone")];
        }
        return false;
      });
      var hasRecipientChain = _this.hasRecipientChain(values);
      var allIneligible = selectedRows.length && !hasRecipientChain ? eligibleSelected.length === 0 : false;
      var conditionName = (0, _messageConditionTranslator["default"])(selectedTemplate.condition);
      var eligibleRecipients = _this.getAllEligibleRecipients(values.method);
      var eligiblePawnIds = !hasRecipientChain ? _this.getConditionalPawnIdsFromRecipients(eligibleRecipients, selectedTemplate.condition) : _this.getConditionalPawnIdsFromRecipients(recipients, selectedTemplate.condition);
      var recipientCount = eligiblePawnIds.length;
      var recipientTotal = _this.state.recipients.length;
      // let sendInfo;
      var sendInfo = selectedRows.length ? "Send to the ".concat(eligibleSelected.length, " ").concat(eligibleSelected.length !== selectedRows.length ? 'eligible' : '', " selected.").concat(selectedRows.length === eligibleSelected.length ? '' : " (".concat(selectedRows.length - eligibleSelected.length, " selected without ").concat(values.method === 'email' ? 'an email address' : 'a phone number', ".)")) : "Send to the ".concat(recipientCount, " ").concat(recipientTotal > recipientCount ? 'eligible' : '', " respondent").concat(recipientCount === 1 ? '' : 's', " ").concat(selectedTemplate.condition === 'all_respondents' ? '' : "meeting condition \"".concat(conditionName, "\"")).concat(recipientTotal === recipientCount ? '' : " (".concat(recipientTotal - recipientCount, " other").concat(recipientTotal - recipientCount > 1 ? 's' : '', " without ").concat(values.method === 'email' ? 'an email address' : 'a phone number', ")."));
      if (allIneligible) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger ".concat(_style["default"].sendInfo),
          role: "alert"
        }, "All selected (", selectedRows.length, ") have an empty", ' ', values.method === 'email' ? 'email address' : 'phone number', ".");
      }
      if (!selectedRows.length && !eligiblePawnIds.length) {
        if (!hasRecipientChain) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "alert alert-danger ".concat(_style["default"].sendInfo),
            role: "alert"
          }, "All respondents ".concat(selectedTemplate.condition === 'all_respondents' ? '' : "meeting condition \"".concat(conditionName, "\""), "\n                     have an empty ").concat(values.method === 'email' ? 'email address' : 'phone number', "."));
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger ".concat(_style["default"].sendInfo),
          role: "alert"
        }, "No respondents match the criteria \"".concat(conditionName, "\"."));
      }
      if (hasRecipientChain) {
        sendInfo = selectedRows.length ? "Attempt to send to the ".concat(selectedRows.length, " selected respondents.") : "Attempt to send to ".concat(selectedTemplate.condition === 'all_respondents' ? "all ".concat(recipients.length, " recipient(s)") : "".concat(eligiblePawnIds.length, " recipient(s) meeting condition \"").concat(conditionName, "\""), ".");
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-info ".concat(_style["default"].sendInfo),
        role: "alert"
      }, sendInfo);
    });
    _defineProperty(_assertThisInitialized(_this), "hasEligibleRecipients", function (values) {
      var messageList = _this.props.messageList;
      var recipients = _this.state.recipients;
      var method = values.method,
        template = values.template;
      var selectedRows = _this.getSelectedRows();
      var selectedTemplate = messageList.find(function (e) {
        return e.messageId === template;
      });
      var hasRecipientChain = _this.hasRecipientChain(values);
      var eligibleRecipients = _this.getAllEligibleRecipients(values.method);
      var eligiblePawnIds = !hasRecipientChain ? _this.getConditionalPawnIdsFromRecipients(eligibleRecipients, selectedTemplate.condition) : _this.getConditionalPawnIdsFromRecipients(recipients, selectedTemplate.condition);
      if (hasRecipientChain) {
        return selectedRows.length || eligiblePawnIds.length;
      }
      if (selectedRows.length) {
        var eligibleSelected = _this.getSelectedRowData().filter(function (row) {
          if (method === 'email') {
            return row["".concat(_this.props.rtComponent.state.userPath, "user.email")];
          }
          if (method === 'sms') {
            return row["".concat(_this.props.rtComponent.state.userPath, "user.phone")];
          }
          return false;
        });
        return eligibleSelected.length > 0;
      }
      return eligibleRecipients.length > 0;
    });
    _defineProperty(_assertThisInitialized(_this), "onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values) {
        var formattedValues, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formattedValues = _this.getPreviewMessageObject(values);
                delete formattedValues.category;
                formattedValues.scheduleTime = _momentTimezone["default"].utc().add(20, 'seconds').format();
                _context2.next = 5;
                return _cccisdAxios["default"].post(Boilerplate.route("api.assignmentDeploymentMessage.store", {
                  deploymentId: _this.props.match.params.deploymentId
                }), formattedValues);
              case 5:
                response = _context2.sent;
                if (!(response.data.status === 'success')) {
                  _context2.next = 9;
                  break;
                }
                _this.props.closeModal();
                // this.props.reloadCurrentProject();
                return _context2.abrupt("return", (0, _cccisdNotification["default"])({
                  type: 'success',
                  message: "Successfully scheduled respondent message \"".concat(formattedValues.settings.label, "\"")
                }));
              case 9:
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: "Failed to schedule respondent message \"".concat(formattedValues.settings.label, "\""),
                  duration: 5000
                });
              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "validate", function (values) {
      var errors = {};
      if (!_this.hasEligibleRecipients(values)) {
        errors._selected = 'All selected are invalid';
      }
      if (values.method === 'email') {
        if (values.actionText && !values.actionUrl) {
          errors.actionUrl = 'You must supply a Button URL if Button Text is provided';
        }
        if (!values.actionText && values.actionUrl) {
          errors.actionText = 'You must supply Button Text if a Button URL is provided';
        }
        if (!values.subject) {
          errors.subject = 'You must supply a Subject';
        }
        if (!values.body && !values.outroLines) {
          errors.body = 'You must supply either Body (upper) or Body (lower)';
          errors.outroLines = 'You must supply either Body (upper) or Body (lower)';
        }
      } else if (!values.body) {
        errors.body = 'You must supply a Body';
      }
      return errors;
    });
    return _this;
  }
  _createClass(SendMessageNow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.getSelectedRows().length) {
        this.getAllRecipients();
      } else {
        this.setState({
          loading: false
        });
      }
    }
  }, {
    key: "render",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function render() {
      var _this2 = this;
      var messageList = this.props.messageList;
      var _this$state = this.state,
        loading = _this$state.loading,
        templateId = _this$state.templateId;
      if (loading) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      var respondentConditions = ['all_respondents', 'complete', 'incomplete', 'incomplete_or_not_started', 'not_started', 'on_respondent_complete'];
      var templates = messageList.filter(function (msg) {
        return msg.category === 'TEMPLATE' && respondentConditions.includes(msg.condition);
      });
      var templateOptions = templates.map(function (item) {
        return {
          label: item.settings.label,
          value: item.messageId
        };
      });
      var methodOptions = [{
        label: 'Email Message',
        value: 'email'
      }, {
        label: 'SMS/Text Message',
        value: 'sms'
      }];
      var selectedTemplate = templates.find(function (e) {
        return e.messageId === templateId;
      });
      if (!selectedTemplate && templates.length) {
        selectedTemplate = templates[0];
      }
      var initialValues = {
        method: 'email'
      };
      if (selectedTemplate) {
        initialValues = Object.assign(initialValues, {
          template: selectedTemplate.messageId,
          subject: selectedTemplate.messageInfo.subject || '',
          body: selectedTemplate.messageInfo.body || '',
          outroLines: selectedTemplate.messageInfo.outroLines || '',
          actionText: selectedTemplate.messageInfo.actionText || '',
          actionUrl: selectedTemplate.messageInfo.actionUrl || '',
          method: selectedTemplate.messageMethod
        });
      } else {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger",
          role: "alert"
        }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, "There are currently no templates to select.")), /*#__PURE__*/_react["default"].createElement("p", null, "Please request that a translator create a template."));
      }
      var initialMethod = initialValues.method;
      if (this.state.method) {
        if (initialMethod !== this.state.method) {
          initialValues.body = '';
        }
        initialValues.method = this.state.method;
      }
      var sendInfo = this.renderSendInfo(initialValues, selectedTemplate);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        initialValues: initialValues,
        enableReinitialize: true,
        onSubmit: this.onSubmit,
        validate: this.validate,
        render: function render(props) {
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "template",
            component: _cccisdFormik.CccisdSelect,
            label: "Template (by Label): *",
            options: templateOptions,
            onChange: function onChange(e) {
              props.handleChange(e);
              _this2.setState({
                templateId: Number.parseInt(e.target.value, 10)
              });
            }
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "method",
            component: _cccisdFormik.CccisdSelect,
            label: "Message Type:",
            options: methodOptions,
            onChange: function onChange(e) {
              props.handleChange(e);
              if (initialMethod !== e.target.value) {
                _this2.editMessageBlock.setShow(true);
              }
              _this2.setState({
                method: e.target.value
              });
            }
          }), /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
            title: "Edit Message",
            ref: function ref(e) {
              _this2.editMessageBlock = e;
            }
          }, props.values.method === 'email' && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "subject",
            component: _cccisdFormik.CccisdInput,
            label: "Subject: *"
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "body",
            component: _cccisdFormik.CccisdTextarea,
            label: "Body".concat(props.values.method === 'email' ? ' (upper)' : '', ":").concat(props.values.method === 'sms' ? ' *' : '')
          }), props.values.method === 'email' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "actionText",
            component: _cccisdFormik.CccisdInput,
            label: "Button Text:"
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "actionUrl",
            component: _cccisdFormik.CccisdInput,
            label: "Button URL:"
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "outroLines",
            component: _cccisdFormik.CccisdTextarea,
            label: "Body (lower):"
          })), /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].subNote
          }, "Note: To place the Data Collection Wave link in the message, type", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, "%URL%"), " and the link will automatically be filled in when the message is sent. You can also insert", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, "%firstName%"), ",", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, "%lastName%"), ", or", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, "%fullName%"), "."), !!Fortress.user.acting.is_super_user && /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].subNote,
            style: {
              marginTop: '1em'
            }
          }, "To specify the URL of a different deployment, you can use one of the following two forms:", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, "%dcwURLByHandle:your_custom_handle_here%"), " or", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, "%dcwURLByEndpoint:your_custom_endpoint_here%"), ". You can specify data starting at the recipient pawn by using a \":\" separated path (e.g.,", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, "%pawn:data:customPawnField%"), ").")), sendInfo, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
            trigger: /*#__PURE__*/_react["default"].createElement("button", {
              type: "button",
              className: "btn btn-default ".concat(_style["default"].button)
            }, "Preview"),
            title: "Previewing message",
            size: props.values.method && props.values.method.toUpperCase() === 'EMAIL' ? 'large' : 'small'
          }, /*#__PURE__*/_react["default"].createElement(_MessageViewer["default"], {
            messageObject: _this2.getPreviewMessageObject(props.values),
            deployment: _this2.props.deployment
          })), /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-primary ".concat(_style["default"].button),
            type: "submit",
            disabled: props.isSubmitting
          }, "Send Message (Right Now)"));
        }
      }));
    }
  }]);
  return SendMessageNow;
}(_react["default"].Component);
_defineProperty(SendMessageNow, "propTypes", {
  rtComponent: _propTypes["default"].object,
  deployment: _propTypes["default"].object,
  messageList: _propTypes["default"].array,
  groupId: _propTypes["default"].number,
  roleHandle: _propTypes["default"].string,
  // From Modal
  closeModal: _propTypes["default"].func,
  // Required for getDeploymentById to work!
  match: _propTypes["default"].object.isRequired,
  // custom message table query
  messageQuery: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string])
});
_defineProperty(SendMessageNow, "defaultProps", {
  closeModal: function closeModal() {}
});
var _default = (0, _withMessageList["default"])(SendMessageNow);
exports["default"] = _default;